import { EAnalyticsEvents } from '@enums/analytics/analytics-events.enum';

export const DASHBOARD_URL_ANALYTICS: { [key: string]: EAnalyticsEvents } = {
  '/dashboard/phones': EAnalyticsEvents.LOADS_PHONE_DASHBOARD,
  '/dashboard/plans/plan-evaluation': EAnalyticsEvents.LOADS_PLAN_EVAL_DASHBOARD,
  '/dashboard/plans/find-plan': EAnalyticsEvents.LOADS_FIND_PLAN_DASHBOARD,
  '/dashboard/deals/saved': EAnalyticsEvents.LOADS_MY_DEALS_DASHBOARD,
};
